/**
 * Default interest tags for seeding account creation
 * Used as fallback when API unavailable
 * Must match backend list for consistency
 */
export const DEFAULT_INTEREST_TAGS = [
  'Thời trang',
  'Làm đẹp',
  'Kinh doanh',
  'Du lịch',
  'Ẩm thực',
  'Công nghệ',
  'Sức khỏe',
  'Thể thao',
  'Game',
  'Phim ảnh',
  'Âm nhạc',
  'Sách',
  'Nhiếp ảnh',
  'Nghệ thuật',
  'Giáo dục',
  'Tài chính',
  'Bất động sản',
  'Ô tô - Xe máy',
  'Thú cưng',
  'Gia đình',
  'Thiền - Yoga',
  'Nội thất',
  'Làm vườn',
  'Nấu ăn',
] as const;

export type InterestTag = typeof DEFAULT_INTEREST_TAGS[number];
